export default {
  resdashboard: "Dashboard",
  resdashboard_subtitle: "Welcome back! Here’s today’s restaurant summary",

  rescredit_limit: "Credit Limit",
  resused_credit: "Used Credit",
  resavailable_credit: "Available",
  resnext_due_date: "Next Due Date",

  restoday_orders: "Today Orders",
  restotal_revenue: "Total Revenue",
  restotal_customers: "Total Customers",
  resavg_rating: "Avg Rating",

  resrecent_orders: "Recent Orders",
  resorder_id: "Order ID",
  rescustomer: "Customer",
  resamount: "Amount",
  resstatus: "Status",
  resno_recent_orders: "No recent orders",

  restop_selling_items: "Top Selling Items",
  resitem_biryani: "Chicken Biryani",
  resitem_paneer: "Paneer Butter Masala",
  resitem_fried_rice: "Fried Rice",
  resorders: "Orders",

  resjan: "Jan",
  resfeb: "Feb",
  resmar: "Mar",
  resapr: "Apr",
  resmay: "May",
  resjun: "Jun",

  ressales_label: "Sales (QAR)",
  resorders: "Orders",
  ressales_overview: "Sales Overview",
  resorders_overview: "Orders Overview",
    ressupplier: "Supplier",

  restoday_spend: "Today Spend",
  respending_orders: "Pending Orders",
  restotal_orders: "Total Orders",

  resmonthly_spend: "Monthly Spend",
  resmonthly_spend_label: "Monthly Spend (QAR)",

  restop_suppliers: "Top Suppliers",
  resamount_qar: "Amount (QAR)",

  resorder_status: "Order Status",

  resorders: "Orders",
  resplaced: "Placed",
resaccepted: "Accepted",
respacked: "Packed",
resdelivered: "Delivered",
resrejected: "Rejected",
resout_for_delivery: "Out For Delivery",
resjan: "Jan",
resfeb: "Feb",
resmar: "Mar",
resapr: "Apr",
resmay: "May",
resjun: "Jun",
resjul: "Jul",
resaug: "Aug",
ressep: "Sep",
resoct: "Oct",
resnov: "Nov",
resdec: "Dec",
};